<template>
    <div id="confirmPaymentPage">
        <div class="d-flex flex-column justify-content-center bg-white px-0 pt-5 pb-4 pb-lg-5 mb-2">
            <merchant-details-opg/>
            <div class="px-4">
                <payment-summary-opg class="mx-auto"/>
            </div>
        </div>
        <div class="d-flex flex-column bg-white p-4">
            <div class="align-items-left">
                <span class="font-sm font-weight-bold text-capitalize">Choose Payment Option</span>
                <br />
                <span class="font-xs text-gray-dk">Pay using your Home Credit funds</span>
            </div>
            <hr />
            <div class="d-flex flex-row">
                <div class="font-sm text-capitalize radio-padding">
                    <div class="custom-control custom-radio custom-checkbox-green">
                        <input type="radio" id="customRadio1" name="customRadio" class="custom-control-input custom-control-input-green" checked="checked">
                        <label class="custom-control-label" for="customRadio1"></label>
                    </div>
                </div>
                <div class="ml-3 icon-padding">
                    <img alt="" src="/img/hcpay/qwarta.svg" class="hc-card-icon img-responsive ml-1">
                </div>
                <div class="ml-3" style="line-height: normal;">
                    <span class="font-sm font-weight-bold text-capitalize ">Home Credit Qwarta</span>
                    <br />
                    <span class="font-xs text-capitalize text-gray-dk">Available Balance: ₱2,000.00</span>
                </div>
            </div>
            <div class="d-flex flex-row warning mt-4">
                <div class="mr-4">
                    <img alt="" src="/img/hcpay/input-error-icon.svg" class="img-responsive errorIcon mr-1">
                </div>
                <div class="font-xs text-danger pt-1">
                    Your payment option does not have enough funds.
                </div>
            </div>
            <div class="d-flex flex-column rounded align-items-center text-center py-5 px-lg-5 px-3">
                <div class="col-10">
                    <button type="button" id="mobileSubmitBtn" @click="submit" class="btn btn-block rounded-lg font-sm text-capitalize font-weight-bold py-2 mt-3 mb-5 btn-success"  modalTrigger>Confirm Payment</button>
                    <cancel-request-opg id="verifyIdentityBackToStore"></cancel-request-opg>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TRANSACTION_STATUS } from '../../mixins/transaction_status.js';
import { ERROR } from '../../mixins/error_codes.js';
import cancelRequest from "./cancel_request_opg2.0.vue"
import moment from 'moment';

const accountTypes = {
    'PHONE' : 'Phone2',
    'FCBKID' : 'Fblogo2'
}

export default {
    components: {
        cancelRequest
    },
    computed: {
        accountTypeIcon() {
            return accountTypes[this.$root.account.type];
        }
    },
    data() {
        return {
            verifyFailCount: 0,
            timerCallback: null,
            expiryDateTime: this.$root.transaction.expiryDate,
        }
    },
    created() {
        this.subscribe();
        this.$root.$data.previousView = 'verify-identity';
    },
    methods: {
        changeView(view) {
            this.$root.$data.view = view;
        },
        timerEnd(callback) {
            this.verifyFailCount++;
            this.timerCallback = callback;
        },
        subscribe() {
            //no content
        },
    },
    watch: {
        verifyFailCount(val) {
            let vm = this;
            if(val==1) {
                vm.$dialog.alert('', {
                    view: 'session-expired-try-again-merchant',
                    html: true,
                    customClass: 'dialog-sm'
                }).then(vm.timerCallback)
                .catch(() => {
                    axios
                    .post("hcpay/cancel_request?tid=" + vm.$root.tid)
                    .then(response => {
                        if(vm.$root.transaction.hasOwnProperty('failedUrl') && vm.$root.transaction.failedUrl != 'undefined') {
                            window.location.href = vm.$root.transaction.failedUrl;
                        } else {
                            vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                        }
                    })
                    .catch(error => {
                        vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                    });
                });
            }else if(val > 1) {
                vm.$dialog.alert('', {
                    view: 'session-expired-back-to-merchant',
                    html: true,
                    customClass: 'dialog-sm'
                }).then(() => {
                    axios
                    .post("hcpay/cancel_request?tid=" + vm.$root.tid)
                    .then(response => {
                        if(vm.$root.transaction.hasOwnProperty('failedUrl') && vm.$root.transaction.failedUrl != 'undefined') {
                            window.location.href = vm.$root.transaction.failedUrl;
                        } else {
                            vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                        }
                    })
                    .catch(error => {
                        vm.$root.error = ERROR.TECHNICAL_PROBLEM;
                    });
                });
            }
        },
    },
}
</script>
<style scoped>
    .input-radio {
        width: 18px;
        height: 18px;
        background: #49B672;
    }
    .accountTypeIcon {
        height: auto;
        width: 1.5rem;
    }
    .verifyIdentityStepIcon {
        height: auto;
        width: 2.5rem;
    }
    .radio-padding {
        padding-top: 7px;
    }
    .icon-padding {
        padding-top: 7px;
    }
    .hc-card-icon {
        width: 32px;
    }
    .warning {
        width: 100%;
        height: 40px;
        padding: 5px 5px 5px 15px;
        /* UI Properties */
        background: #FFF7F7 0% 0% no-repeat padding-box;
        border-radius: 4px;
        opacity: 1;
    }
    .errorIcon {
        width: 24px;
    }
    .custom-control-input-green:focus~.custom-control-label::before {
        border-color: #28a745 !important;
        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;        
    }

    .custom-control-input-green:checked~.custom-control-label::before {
        border-color: #28a745 !important;
        background-color: #28a745 !important;
    }

    .custom-control-input-green:focus:not(:checked)~.custom-control-label::before {
        border-color: #5bd778 !important;
    }

    .custom-control-input-green:not(:disabled):active~.custom-control-label::before {
        background-color: #d6f5dd !important;
        border-color: #d6f5dd !important;
    }
</style>